var React = require('react');

function CheckIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.1648 0.273211C17.5626 0.639833 17.5626 1.23267 17.1648 1.56417L6.86824 11.8607C6.53673 12.2585 5.9439 12.2585 5.57728 11.8607L0.274145 6.55641C-0.0913815 6.2249 -0.0913815 5.63207 0.274145 5.26545C0.639632 4.90274 1.23246 4.90274 1.59791 5.26545L6.24031 9.91059L15.8738 0.273211C16.2404 -0.0910702 16.8332 -0.0910702 17.1648 0.273211Z","fill":"currentColor"}));
}

CheckIcon.defaultProps = {"width":"18","height":"13","viewBox":"0 0 18 13","fill":"none"};

module.exports = CheckIcon;

CheckIcon.default = CheckIcon;
